import { render, staticRenderFns } from "./BranchManage.vue?vue&type=template&id=b5c65752&scoped=true&"
import script from "./BranchManage.vue?vue&type=script&lang=js&"
export * from "./BranchManage.vue?vue&type=script&lang=js&"
import style0 from "./BranchManage.vue?vue&type=style&index=0&id=b5c65752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c65752",
  null
  
)

export default component.exports